import { getAccount } from '../../api/apiClient';
import { extractHighschoolAccountInfo } from '../highschool';

/**
 * ログイン中のアカウントに既にサブメールアドレスが登録済み (アカウント統合済み) かを返す。
 * マイページのサブメールアドレス欄の表示と判定を揃えるため extractHighschoolAccountInfo を用いる。
 *
 * 取得に失敗した場合は false を返し、画面を塞いだまま詰まないようにする。
 * 統合の実行自体はサーバー側が 409 で拒否するため、ここでの取りこぼしは表示の問題に留まる。
 */
export async function hasIntegratedSubEmail(): Promise<boolean> {
  try {
    const { data } = await getAccount();
    if (!data) {
      return false;
    }
    return extractHighschoolAccountInfo(data)?.integrated === true;
  } catch {
    return false;
  }
}
